var lastScroll = 0;
window.addEventListener('scroll', (e)=>{
  let scrollCount = window.pageYOffset;
  document.querySelector('body').classList.add('solid_header');
  if(scrollCount == 0){
    document.querySelector('body').classList.remove('solid_header');
  }
  setTimeout(function(){
    if(scrollCount > lastScroll){
      document.querySelector('body').classList.remove('scroll-up');
      document.querySelector('body').classList.add('scroll-down');
    }else if(scrollCount < lastScroll){
      document.querySelector('body').classList.remove('scroll-down');
      document.querySelector('body').classList.add('scroll-up');
    }
    lastScroll = scrollCount;
  }, 0);
  let header = document.getElementById('shopify-section-header');
  if(scrollCount > header.offsetTop){
    header.classList.add('sticky_header');
  }
  if(scrollCount < document.getElementById('shopify-section-announcement-bar').clientHeight && document.querySelector('body').classList.contains('scroll-up')) header.classList.remove('sticky_header');
})
document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll('.mobile-search').forEach(function(searchButton){
    searchButton.addEventListener('click',function(e){
      document.querySelector('body').classList.toggle('open-search');
      if(document.querySelector('.header-lang-menu')) document.querySelector('.header-lang-menu').style.maxHeight = '';
      document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter','active-popup','open-currency');
      if(document.querySelector(".mobile-serachbox #Search")) document.querySelector(".mobile-serachbox #Search").focus();
    });
  });
  if(document.querySelector('.search-button')) document.querySelector('.search-button').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter','active-popup','open-currency');
    document.querySelector("#Search").focus();
  })
  document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
    menuBurger.addEventListener('click',function(e){
      document.querySelector('body').classList.toggle('open-menu');
      document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter','active-popup','open-currency');
      if(document.querySelector('body').classList.contains('open-menu')){
        document.querySelector('.mob-menuwrap').style.transform = "translate(0%)";
      }
    });
  });
  if(document.querySelector('.active_currency')) document.querySelector('.active_currency').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.toggle('open-currency');
    if(document.querySelector('.newsltr-popup')) document.querySelector('.newsltr-popup').style.maxHeight = '';
    document.querySelector('body').classList.remove('open-newsltr','open-drawer','open-search','open-sort','open-filter','active-popup');
    if(document.querySelector('body').classList.contains('open-currency')){
      document.querySelector('.overlay-box').style.zIndex = 1;
    }
  });
  
  if(document.querySelector('.mb_currency')) document.querySelector('.mb_currency').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('body').classList.add('open-currency');
    if(document.querySelector('body').classList.contains('open-currency')){
       document.querySelector('.mob-menuwrap').style.transform = "translate(-100%)";
    }else{
      document.querySelector('.mob-menuwrap').style.transform = "translate(0%)";
    }
  });
  
  if(document.querySelector('.back-to-nav')) document.querySelector('.back-to-nav').addEventListener('click',function(e){
    console.log('back-to-nav');
    document.querySelector('body').classList.remove('open-currency');
    document.querySelector('.mob-menuwrap').style.transform = "translate(0%)";
  });
  
});
if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > .mega-list').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active-menu');
      if(navList.querySelector('.mega-main-grid')){
        let height = navList.querySelector('.mega-left').offsetHeight;
        if(document.querySelector('.header-left:has(.mega-list.active-menu) .header-menu-overly')) document.querySelector('.header-left:has(.mega-list.active-menu) .header-menu-overly').style.height = height+'px';
        if(navList.querySelector('.mega-right')) navList.querySelector('.mega-right').style.maxHeight = height+'px';
        setTimeout(() => {
          if(document.querySelector('.header-left:has(.mega-list.active-menu) .header-menu-overly')) document.querySelector('.header-left:has(.mega-list.active-menu) .header-menu-overly').classList.add('active');
        }, 200);
      }
    });
    navList.addEventListener('mousemove', function(){
      navList.classList.add('active-menu');
      if(navList.querySelector('.mega-main-grid')){
        let height = navList.querySelector('.mega-left').offsetHeight;
        if(document.querySelector('.header-left:has(.mega-list.active-menu) .header-menu-overly')) document.querySelector('.header-left:has(.mega-list.active-menu) .header-menu-overly').style.height = height+'px';
        if(navList.querySelector('.mega-right')) navList.querySelector('.mega-right').style.maxHeight = height+'px';
        setTimeout(() => {
          if(document.querySelector('.header-left:has(.mega-list.active-menu) .header-menu-overly')) document.querySelector('.header-left:has(.mega-list.active-menu) .header-menu-overly').classList.add('active');
        }, 200);
      }
    });
    navList.addEventListener('mouseout', function(){
      document.querySelector('.header-menu-overly').style.height = '';
      setTimeout(() => {
        if(document.querySelector('.header-left:has(.mega-list.active-menu) .header-menu-overly')) document.querySelector('.header-left:has(.mega-list.active-menu) .header-menu-overly').classList.remove('active');
      }, 200);
      navList.classList.remove('active-menu');
    });
  });
}
// document.querySelectorAll('.mega-listmenu').forEach((megaList) => {
//   megaList.querySelectorAll('li a').forEach((megaVal) => {
//     megaVal.addEventListener('mouseover', function(){
//       let img = megaVal.getAttribute('data-img');
//       if(img) megaVal.closest('.mega-main-grid').querySelector('.mega-image img').setAttribute('srcset',img);
//     })
//     megaVal.addEventListener('mouseout', function(){
//       let img = megaVal.closest('.mega-main-grid').querySelector('.mega-image img').getAttribute('src');
//       if(img) megaVal.closest('.mega-main-grid').querySelector('.mega-image img').setAttribute('srcset',img);
//     });
//   })
// })
document.querySelectorAll('.mega-listmenu').forEach((megaList) => {
  megaList.querySelectorAll('li a').forEach((megaVal) => {
    megaVal.addEventListener('mouseover', function(){
      let img = megaVal.getAttribute('data-img');
      if(img){
        megaVal.closest('.mega-main-grid').querySelector('.mega-image img').classList.remove('d-none');
        megaVal.closest('.mega-main-grid').querySelector('.mega-image img').setAttribute('srcset',img);
      }else{
        megaVal.closest('.mega-main-grid').querySelector('.mega-image img').classList.add('d-none');
        megaVal.closest('.mega-main-grid').querySelector('.mega-image img').setAttribute('srcset','');
      }
    })
    megaVal.addEventListener('mouseout', function(){
      megaVal.closest('.mega-main-grid').querySelector('.mega-image img').classList.add('d-none');
    });
  })
})
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      panel: this.querySelector('ul'),
    };
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }
  hidePanel() {
    this.elements.panel.setAttribute('hidden', true);
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
  openSelector() {
    this.elements.panel.toggleAttribute('hidden');
  }
  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);